export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '657c4468-9c4a-4b70-88d9-e5e6f72737ba';
export const MODAL_CLOSE_SEC = 2.5;
